export default __webpack_public_path__ + "3a8dfda7b6f0a244039a78f24320e94e.jpg";